import { Injector, Pipe, PipeTransform } from '@angular/core';
import { IFormRule, FormElementRegistry, ViewRuleRegistry, Farris, FrameContext, IButtonViewRule } from '@farris/devkit';
import { BehaviorSubject } from 'rxjs';
import { ToolbarPipe } from './toolbar_pipe';
@Pipe({ name: 'toolbarUsability' })
export class ToolbarUsabilityPipe extends ToolbarPipe implements PipeTransform {
  private subjects: Map<string, BehaviorSubject<any>> = new Map<string, BehaviorSubject<any>>();
  constructor(protected injector: Injector, protected formElementRegistry: FormElementRegistry, private viewRuleRegistry: ViewRuleRegistry, protected frameContext: FrameContext) {
    super(injector, frameContext, formElementRegistry);
  }
  /**
   * è®¡ç®å·¥å·æ æé®æ¯å¦å¯ç¨
   * @param config - toolbarItemç¼å·åå¶å½åå¼
   * @param toolbarId - å·¥å·æ idï¼éåé¨æé®é¡¹id
   * @param version - version
   * @description æé®å¼ä¸ºtrueæ¶è¡¨ç¤ºç¦ç¨ï¼falseæ¶è¡¨ç¤ºå¯ç¨
   */
  transform(config: any, toolbarId: string, version: any) {
    if (!this.subjects.has(toolbarId)) {
      this.subjects.set(toolbarId, new BehaviorSubject<any>(null));
    }
    const subject = this.subjects.get(toolbarId);
    // å¤çconfig
    this.process(config, Farris.FormRule.RuleType.Disabled);
    if (!this.formElementRegistry || !this.viewRuleRegistry) {
      subject.next(config);
      return subject;
    }
    Object.keys(config).forEach((toolbarItemId: string) => {
      const toolbarItem = this.formElementRegistry.getElementById(toolbarItemId);
      if (toolbarItem) {
        const viewRule = this.viewRuleRegistry.getRuleById(toolbarItemId) as IButtonViewRule;
        if (viewRule) {
          // å¼ä¸ºtrueæ¶è¡¨ç¤ºç¦ç¨ï¼falseæ¶è¡¨ç¤ºå¯ç¨
          const ruleDisabled = viewRule.disabled;
          const elementRule = toolbarItem.rules.find((item: IFormRule) => item.type === Farris.FormRule.RuleType.Disabled);
          // è§åè®¾ç½®ä¸ºå¯ç¨
          if (!ruleDisabled) {
            if (!elementRule.dynamic) {
              config[toolbarItemId] = false;
            }
          } else {
            config[toolbarItemId] = true;
          }
        }
      }
    });
    subject.next(config);
    return subject;
  }
}
